
import { Vue, Component, Prop } from 'vue-property-decorator';
import { ShipFrom, ShipTo } from '@/features/shipment/types';
import { getGoogleMapsUrlFromAddress } from '@/features/shipment-history/helpers';
import moment from 'moment';

@Component
export default class AddressInfo extends Vue {
  @Prop({ default: 'from' }) location!: 'from' | 'to';

  @Prop({ required: true }) addressData!: ShipFrom | ShipTo;

  @Prop({ default: '' }) encodedImage!: string;

  get title(): string {
    return this.$t(`global.${this.location === 'from' ? 'origin' : 'destination'}`) as string;
  }

  get contactDetails(): string {
    const {
      company, contact, emails, phone,
    } = this.addressData;

    return `${company}<br />
      ${contact}<br />
      ${emails && emails[0] ? `<span data-clarity-mask="True">${emails[0]}</span><br />` : ''}
      <span data-clarity-mask="True">${phone}</span>`;
  }

  get addressInfo(): string {
    const countryName = this.getCountryNameFromCode(this.addressData.countryCode);
    const addresses = [
      this.addressData.addr1,
      this.addressData.addr2,
      (this.addressData as ShipTo).addr3,
    ].filter(Boolean).join('<br />');

    const cityData = [
      this.addressData.city,
      this.addressData.province,
      this.addressData.postalCode,
    ].filter(Boolean).join(' ');

    return `${addresses}<br />${cityData}<br />${countryName}`;
  }

  get appointmentInfo(): string {
    const {
      appointmentType, date, time,
    } = this.addressData.appointment || {};

    if (!appointmentType || appointmentType !== 'Scheduled') return '';

    try {
      return `${moment(date).format('YYYY-MM-DD')}<br>${moment(time, 'HH:mm').format('h:mm A')}`;
    } catch {
      return '';
    }
  }

  get addressMapUrl(): string {
    const {
      countryCode, postalCode, city, addr1, province,
    } = this.addressData;

    return getGoogleMapsUrlFromAddress({
      countryCode,
      postalCode,
      city,
      addr1,
      province,
    });
  }

  private getCountryNameFromCode(code: string): string {
    const countryInfo = this.$store.getters.getCountryFromCode(code);

    if (!countryInfo) return '';

    return countryInfo.country;
  }
}
